import {useEffect, useState} from "react";
import {IAdSpace} from "../core/interfaces/IAd.ts";

type AdsContainerProps = {
  vertical?: boolean;
  debug?: boolean;
  containerWidth?: string;
  containerHeight?: string;
  size?: number;
  relation?: number;
  ads: IAdSpace[];
}

const POST_RELATION = 5 // will be 1:6

export default function AdsContainer(props: AdsContainerProps) {
  const [ childWidth, setChildWidth ] = useState<number>(0)
  const [ childHeight, setChildHeight ] = useState<number>(0)

  const [ containerWidth ] = useState<string>(props.containerWidth || '100%')
  const [ containerHeight ] = useState<string>(props.containerHeight || '100%')

  useEffect(() => {
    const size = props.size ?? 70;
    const relation = props.relation ?? POST_RELATION

    if (props.vertical) {
      setChildWidth(size)
      setChildHeight(size * relation)
      return
    }

    setChildHeight(size)
    setChildWidth(size * relation)
  }, []);

  if (props.ads.length === 0) return null

  return <div
    className={'d-flex align-items-center justify-content-center'}
    style={{
      width: containerWidth,
      height: containerHeight,
      flexDirection: props.vertical ? 'column' : 'row',
    }}
  >
    {props.ads?.filter((u: IAdSpace) => !!u.fileURI).map((u: IAdSpace) => <AdsChild debug={props.debug}
                                      width={childWidth}
                                      height={childHeight}
                                      fileURL={u.fileURI}
                                      redirectUrl={u.ad?.linkTo}

    />)
    }
  </div>
}

type AdsChildProps = {
  width: number;
  height: number;
  debug?: boolean;
  fileURL?: string;
  redirectUrl?: string;
}

export function AdsChild(props: AdsChildProps) {
  return <a
    className={'ads-child ads-top'}
    href={props.redirectUrl}
    target={'_blank'}
    style={{
      width: props.width,
      height: props.height,
      border: props.debug ? '1px solid blue' : 'none',
      position: 'relative'
    }}
  >
    <img
      src={props.fileURL}
      width={'100%'}
      height={'auto'}
    />
  </a>
}
